import { RESORTS_WITHOUT_WE_SKI } from 'ots-constants';

export const isResortWithoutWeSki = (resortId: string, locale?: string, skipLocaleCheck?: boolean) => (
  RESORTS_WITHOUT_WE_SKI.some((resort) => (resort.locale === locale && resort.resortId === resortId)
  || (resort.locale === undefined && resort.resortId === resortId) || (skipLocaleCheck && resort.resortId === resortId))
);
